<template>
  <!-- Overlay -->
  <div
    v-if="getOverlay.active"
    class="fixed w-full h-full top-0 left-0 bg-black bg-opacity-25"
    style="z-index: 10000;"
  >
    <div
      class="bg-white rounded relative overflow-auto"
      :class="getIsMobile ? 'mobile-overlay' : 'desktop-overlay'"
    >
      <button
        class="bg-gray-700 hover:bg-gray-500 font-extrabold text-white rounded-full"
        :class="getIsMobile ? 'mobile-fixed-button' : 'desktop-fixed-button'"
        @click.stop="closeOverlay"
      >
        X
      </button>
      <div
        class="p-8 md:p-20 break-words font-normal lato-text text-xl"
        v-html="getAboutContent"
      ></div>
    </div>
  </div>
</template>

<style scoped>
.mobile-fixed-button {
  position: fixed;
  width: 2em;
  height: 2em;
  transform: translate(calc(90vw - 3em), 1em);
}

.desktop-fixed-button {
  position: fixed;
  width: 2em;
  height: 2em;
  transform: translate(calc(50vw - 3em), 1em);
}

.mobile-overlay {
  width: 90vw;
  height: 90vh;
  left: 5vw;
  top: 5vh;
  overflow: auto;
}

.desktop-overlay {
  position: absolute;
  width: 50vw;
  max-height: 80vh;
  left: 25vw;
  top: 10vh;
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getIsMobile", "getAbout", "getTermsOfUse", "getOverlay"]),
    getAboutContent() {
      return this.getOverlay.content;
    },
  },
  watch: {
    "getOverlay.active": (isTrue) => {
      if (isTrue) {
        document.body.style.overflow = "hidden";
      } else document.body.style.overflow = "auto";
    },
  },
  methods: {
    ...mapMutations(["setOverlay"]),
    closeOverlay() {
      const obj = {
        active: false,
        title: "",
        content: "",
      };
      this.setOverlay(obj);
    },
  },
};
</script>
